import React from 'react';
import { FunnelIcon, ChevronDownIcon } from '@heroicons/react/24/outline';
import { Card } from './Card';

const FilterPanel = ({
  title = 'Filters',
  isOpen = true,
  onToggle,
  className = '',
  headerRight,
  compact = false,
  children,
}) => {
  return (
    <Card className={`bg-white dark:bg-gray-800 shadow-sm border border-gray-200 dark:border-gray-700 ${className}`.trim()}>
      <div className={compact ? 'p-2' : 'p-4'}>
        <div
          className={`flex items-center justify-between ${compact ? (isOpen ? 'mb-1.5' : 'mb-0') : 'mb-4'} ${
            onToggle ? 'cursor-pointer select-none' : ''
          }`}
          onClick={onToggle || undefined}
          onKeyDown={
            onToggle
              ? (e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onToggle();
                  }
                }
              : undefined
          }
          role={onToggle ? 'button' : undefined}
          tabIndex={onToggle ? 0 : undefined}
          aria-expanded={onToggle ? isOpen : undefined}
        >
          <div className="flex items-center space-x-1.5">
            <FunnelIcon className={compact ? 'w-3.5 h-3.5 text-gray-500 dark:text-gray-400' : 'w-4 h-4 text-gray-500 dark:text-gray-400'} />
            <h3 className={`${compact ? 'text-xs' : 'text-sm'} font-medium text-gray-900 dark:text-white`}>{title}</h3>
          </div>

          <div className="flex items-center gap-2">
            {headerRight ? (
              <div
                onClick={(e) => e.stopPropagation()}
                onKeyDown={(e) => e.stopPropagation()}
              >
                {headerRight}
              </div>
            ) : null}
            {onToggle ? (
              <span className="flex items-center space-x-1 text-[11px] text-gray-500 dark:text-gray-400">
                {!compact ? <span>Advanced Search</span> : null}
                <ChevronDownIcon
                  className={`w-3 h-3 transition-transform ${isOpen ? 'rotate-180' : ''}`}
                />
              </span>
            ) : null}
          </div>
        </div>

        {isOpen ? children : null}
      </div>
    </Card>
  );
};

export default FilterPanel;
